module.exports = __webpack_public_path__ + "img/Cafe01.c4d34f6d.png";